export default {
      id: "publish-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#publish-usage",
      toString: function () {
        return this.url;
      }
    }